// @flow

import {
	SelectBaseStrategy,
} from 'rgs-nfd-ui-kit/ko-components/select/base-strategy';
import type { ISelectStrategy } from 'rgs-nfd-ui-kit/ko-components/select/index.flow';
import type {
	SettlementShortModel, StreetDetailModel, StreetShortModel,
} from 'app-my-account/services/kladr/api-models/kladr.flow';
import ko from 'rgs-knockout';
import type { SelectBaseStrategyOptions } from 'rgs-nfd-ui-kit/ko-components/select/base-strategy';
import { AddressSettlement } from 'app-my-account/models/address';

export type StrategyStreetsOptions = SelectBaseStrategyOptions<SettlementShortModel> & {
	settlement: AddressSettlement,
	onClickItem: (street: StreetShortModel)=>Promise<void>,
	onClickCancel: ()=>void,
}

export class StrategyStreets extends SelectBaseStrategy<SettlementShortModel>
	implements ISelectStrategy<SettlementShortModel> {

	withSearch = ko.observable(true);
	pathToId = 'Kladr';
	pathToName = 'Name';
	minLengthSearchWord = 1;

	_options: StrategyStreetsOptions;

	async onClickItem (street: SettlementShortModel) {
		await super.onClickItem(street);

		await this._options.onClickItem(street);
	}

	setCurrentStreet (street: SettlementShortModel | StreetDetailModel) {
		this.currentValue(street);
	}

	onClickCancel () {
		super.onClickCancel();

		this._options.onClickCancel();
	}
}

